import Telemetry from '@atlassian/mpac-telemetry';
export const viewHomeEnterpriseSectionTask = 'view-home-enterprise-section';
export const viewHomeSectionTask = 'view-home-sections';
export const viewProductEnterpriseSectionTask = 'view-product-enterprise-section';
export const viewProductSectionTask = 'view-product-sections';
export const ViewHomeEnterpriseSection = Telemetry.createGenericTask(viewHomeEnterpriseSectionTask);
export const ViewHomeSections = Telemetry.createGenericTask(viewHomeSectionTask);
export const HomePageTask = Telemetry.createPageViewTask('view-home-page').dependsOn([ViewHomeEnterpriseSection, ViewHomeSections]);
export const ViewProductEnterpriseSection = Telemetry.createGenericTask(viewProductEnterpriseSectionTask);
export const ViewProductSections = Telemetry.createGenericTask(viewProductSectionTask);
export const setupProductHomepageTask = isEnterpriseSectionVisible => {
  if (isEnterpriseSectionVisible) {
    return Telemetry.createPageViewTask('view-product-page').dependsOn([ViewProductSections, ViewProductEnterpriseSection]);
  } else {
    return Telemetry.createPageViewTask('view-product-page').dependsOn([ViewProductSections]);
  }
};